import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TraineeListService } from "../../service/trainee-list.service";
import { TraineeSummary } from "../../model/rolePlay.model";
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RoleplayApiService } from '../../service/roleplay.service';
@Component({
    selector: 'app-user-assigned-roleplay',
    templateUrl: './user-assigned-roleplay.component.html',
    styleUrl: './user-assigned-roleplay.component.scss',
    standalone: false
})

export class UserAssignedRoleplayComponent {
  
  wwidParam: number = 0;
  traineeDetails: TraineeSummary;
  userId: number = 0;
  filterValue: string;
  rolePlayStatus: string;
  dataSource: any = new MatTableDataSource();
  showNoSearchResultsMessage: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) private paginator: MatPaginator;

  displayedColumns: string[] = ['chat_type', 'chat_start_time', 'chat_topic'];

  constructor(public Router: Router, private activateRoute: ActivatedRoute,
    public TraineeService: TraineeListService, private _liveAnnouncer: LiveAnnouncer, private rolePlayService: RoleplayApiService) { }

  backbutton() {
    this.Router.navigate(['/app-trainee-detail'], { skipLocationChange: true, queryParams: {id: this.wwidParam} });
  }

  
  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.userId = Number(sessionStorage.getItem('userId'));
    this.wwidParam = Number(this.activateRoute.snapshot.queryParamMap.get('id'));
    this.rolePlayStatus = this.activateRoute.snapshot.queryParamMap.get('status');
    this.getUserSummary();
  }
  applyFilter(value: string) {
    this.filterValue = value.trim().toLowerCase();
    this.dataSource.filter = this.filterValue;

    // Check if there are any items after applying the filter
    if (this.dataSource.filteredData.length === 0 && this.filterValue !== '') {
      this.showNoSearchResultsMessage = true; // Set a flag to indicate no search results
    } else {
      this.showNoSearchResultsMessage = false; // Reset the flag
    }
  }
  getUserSummary() {
    // this.TraineeService.getTraineeSummaryById(this.scenarioId).subscribe((response: TraineeSummary)=> {
    this.TraineeService.getTraineeRolePlaySummaryById(this.wwidParam).subscribe((response: any) => {

      if (response.length) {
      if (this.rolePlayStatus === 'Completed') {
        response = response.filter(item => item.roleplay_status === "Completed");
        if (!response.length) {
          this.showNoSearchResultsMessage = true;
        }
      }
      this.dataSource = new MatTableDataSource(response);
    } else {
      this.showNoSearchResultsMessage = true;
    }
    
    this.dataSource.paginator = this.paginator;
    });
  }
  formatTime(totalMinutes: number, remainingSeconds: number): string {
    const totalSeconds = (totalMinutes * 60) + remainingSeconds;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  sortData(sort: Sort) {
    if (sort.direction) {
      this._liveAnnouncer.announce(`Sorted ${sort.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  userinfo(wwid: number) {
    this.Router.navigate(['/user-assigned-roleplay'], { skipLocationChange: true, queryParams: {id: wwid} });
  }

  cardClickHandler(chat_session_id: any) {
   this.Router.navigate([`app-trainer-assigned-roleplay`, chat_session_id, this.wwidParam], { skipLocationChange: true });
 }
}
